import styled from "styled-components";

export const PaginationWrap = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 24px;
	width: 100%;
	position: relative;
	min-height: 80px;
	
	@media screen and (max-width: 768px) {
		padding: 16px 8px;
		flex-wrap: wrap;
		gap: 16px;
		min-height: auto;
	}
`;

export const PaginationButton = styled.button<{ disabled?: boolean }>`
	display: flex;
	align-items: center;
	gap: 8px;
	background: none;
	border: none;
	color: ${props => props.disabled ? '#D1D5DB' : '#6B7280'};
	font-family: BeVietnamPro;
	font-size: 14px;
	font-weight: 500;
	cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
	transition: color 0.2s ease;

	&:hover {
		color: ${props => props.disabled ? '#D1D5DB' : '#374151'};
	}
`;

export const PageNumbers = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
	position: absolute;
	left: 50%;
	transform: translateX(-50%);
	flex-wrap: wrap;
	max-width: calc(100% - 300px);
	justify-content: center;
	
	@media screen and (max-width: 768px) {
		position: relative;
		left: auto;
		transform: none;
		max-width: 100%;
		order: 2;
		gap: 4px;
	}
`;

export const NavigationButtons = styled.div`
	display: flex;
	align-items: center;
	gap: 16px;
	position: absolute;
	right: 30px;
	
	@media screen and (max-width: 768px) {
		position: relative;
		right: auto;
		width: 100%;
		justify-content: center;
		order: 1;
		gap: 8px;
	}
`;

export const PageNumber = styled.button<{ active?: boolean }>`
	width: 32px;
	height: 32px;
	border-radius: 50%;
	border: none;
	background: ${props => props.active ? '#E5E7EB' : 'transparent'};
	color: ${props => props.active ? '#374151' : '#6B7280'};
	font-family: BeVietnamPro;
	font-size: 14px;
	font-weight: 500;
	cursor: pointer;
	transition: all 0.2s ease;
	box-shadow: ${props => props.active ? '0 1px 3px rgba(0, 0, 0, 0.1)' : 'none'};

	&:hover {
		background-color: ${props => props.active ? '#E5E7EB' : '#F3F4F6'};
		color: #374151;
	}
`;

export const Ellipsis = styled.span`
	color: #6B7280;
	font-family: BeVietnamPro;
	font-size: 14px;
	
	@media screen and (max-width: 768px) {
		font-size: 12px;
	}
`;
